import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getRouter } from "./router";
import { AuthProvider } from "@/contexts/AuthContext";
import { logger } from "@/lib/logger";
import { initAppearance } from "@/lib/appearance";
import { getCoreApiUrl, getApiBaseUrl, getAppVersion } from "@/lib/runtime-config";
import { ApiError } from "@/services/api/errors";
import "./styles.css";

initAppearance();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // 4xx (404, 401, 403, etc.) son errores permanentes: reintentar no
        // cambia el resultado, solo genera ruido y peticiones de más.
        const status = error instanceof ApiError ? error.status : undefined;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});
const router = getRouter(queryClient);

logger.info("[Runtime] CORE_API_URL:", getCoreApiUrl());
logger.info("[Runtime] API_BASE_URL:", getApiBaseUrl());
logger.info("[Runtime] APP_VERSION:", getAppVersion());

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");

createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </QueryClientProvider>,
);
